import { Hub, HubCallback } from '@aws-amplify/core';

/**
 * When a sign-in through Cognito's hosted UI fails (for instance the
 * PreSignUp trigger rejecting a Google sign-in), Cognito comes back to a new
 * page with the error in the URL, and Amplify reports it while
 * `Amplify.configure` handles that return — before anything renders. The
 * message is kept here until the sign-in form shows it.
 *
 * Bootstrap plumbing, like `identityClaimSession.ts`: has to be listening
 * before `Amplify.configure`.
 */

let pendingFailure: string | null = null;

/** The URL-encoded `error_description`, without the trigger's prefix. */
const failureMessage = (raw: string): string => {
  const spaced = raw.replace(/\+/g, ' ');
  let decoded = spaced;
  try {
    decoded = decodeURIComponent(spaced);
  } catch {
    // A malformed escape: show the rest as it came.
  }
  return decoded.replace(/^\s*PreSignUp failed with error\s*/, '').trim();
};

export const listenForHostedUIFailure = () => {
  const listener: HubCallback = ({ payload }) => {
    if (payload.event !== 'cognitoHostedUI_failure') return;
    const raw: unknown = payload.data?.message;
    if (typeof raw === 'string' && raw) pendingFailure = failureMessage(raw);
  };
  return Hub.listen('auth', listener);
};

/** The failure of the last return from the hosted UI, once. */
export const takeHostedUIFailure = (): string | null => {
  const failure = pendingFailure;
  pendingFailure = null;
  return failure;
};
